'use client';

import { useEffectOnce } from '@carvana/merch-react-hooks';
import Composer from '@/common/Composer';
import { HOME_STARTER_QUESTIONS } from '~/constants/home';
import { useTrackEvent } from '~/context/common/AnalyticsProvider';
import { useShowComposerTreatment } from '~/context/composer/ComposerContext';
import useTypeQuestionThenOpenComposer from '~/hooks/home/useTypeQuestionThenOpenComposer';
import HomeStarterQuestion from './HomeStarterQuestion';

export default function HomeComposerUi() {
  const showComposerTreatment = useShowComposerTreatment();
  const trackEvent = useTrackEvent();
  const { displayText, isTyping, startTyping } =
    useTypeQuestionThenOpenComposer();

  useEffectOnce(
    () => {
      trackEvent('composer_shell_loaded', {
        chipsOffered: HOME_STARTER_QUESTIONS,
        page: 'home'
      });
    },
    [trackEvent],
    showComposerTreatment
  );

  if (!showComposerTreatment) return null;

  return (
    <div className="fixed inset-x-0 bottom-0 z-40">
      <Composer
        displayText={displayText}
        inputPlaceholder="Search or ask me anything"
        slot={
          <HomeStarterQuestion
            disabled={isTyping}
            onSelectAction={startTyping}
            questions={HOME_STARTER_QUESTIONS}
          />
        }
      />
    </div>
  );
}
